import {Dashboard} from "../models/dashboard/Dashboard";
import {BaseEvent} from "./BaseEvent";

export class DeleteDashboardEvent extends BaseEvent {
  public static NAME = 'deleteDashboard';

  value: Dashboard;

  constructor(dashboard: Dashboard) {
    super(DeleteDashboardEvent.NAME);
    this.value = dashboard;
  }
}
